import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as smartConnectServices from "../../../services/smartConnect/smartConnect.services.js";

export const fetchSmartConnectAgents = createAsyncThunk(
    "smartConnectAgents/fetch",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await smartConnectServices.getSmartConnectAgents(payload);

            if (!res?.success) {
                return rejectWithValue(
                    res?.message || "Failed to fetch Smart Connect Agents"
                );
            }

            return {
                data: res?.data || [],
                pagination: res?.pagination || {},
            };
        } catch (err) {
            return rejectWithValue(
                err?.response?.data?.message ||
                "Internal Server Issue while fetching Smart Connect Agents"
            );
        }
    }
);

export const updateAgent = createAsyncThunk(
    "smartConnectAgents/update",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await smartConnectServices.updateAgent(payload);
            if (!res?.success) {
                return rejectWithValue(
                    res?.message || "Failed to update Agents"
                );
            }
            else {
                return res.message || "Agent Successfully Updated.";
            }
        } catch (err) {
            return rejectWithValue(
                err?.response?.data?.message ||
                "Internal Server Issue while updating Agent"
            );
        }
    }
);

export const bulkAddSmartConnectAgents = createAsyncThunk(
    "smartConnectAgents/bulkAdd",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await smartConnectServices.bulkAddSmartConnectAgents(payload);
            if (!res?.success) {
                return rejectWithValue(
                    res?.message || "Failed to update Agents"
                );
            }
            else {
                return res.message || "Agents Successfully Uploaded.";
            }
        } catch (err) {
            return rejectWithValue(
                err?.response?.data?.message ||
                "Internal Server Issue while updating Agents"
            );
        }
    }
);

const initialState = {
    data: [],
    pagination: {},
    loading: false,
    error: null,
};

const smartConnectAgentsSlice = createSlice({
    name: "smartConnectAgents",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSmartConnectAgents.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSmartConnectAgents.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload.data;
                state.pagination = action.payload.pagination;
            })
            .addCase(fetchSmartConnectAgents.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});



export const smartConnectAgentsReducer =
    smartConnectAgentsSlice.reducer;
